module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Adventures of the Karillapig")]), _vm._v(" "), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-one-the-karillapig-comes-to-earth"
    }
  }, [_vm._v("Chapter One: The Karillapig Comes to Earth")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-two-being-sick-on-slippers-spells-travel-disruption-for-k-pig"
    }
  }, [_vm._v("Chapter Two: Being Sick on Slippers Spells Travel Disruption for K-Pig")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-three-potential-space-travel-a-wash-out-for-k-pig",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three: Potential Space Travel a Wash Out for K-pig")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-four-has-k-pig-got-space-travel-off-to-a-tee",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four: Has K-Pig Got Space Travel off to a Tee?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-five-here-is-an-interesting-moon-fact-i-am-sure-you-do-not-know",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five: Here Is an Interesting Moon Fact I am Sure You Do Not Know…")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-six-burning-question-are-fish-in-politics",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: Burning Question: Are Fish in Politics?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-seven-wrongly-buttoned-up-cardigans-can-cause-all-sorts-of-issues-apparently-who-knew",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven: Wrongly Buttoned-Up Cardigans Can Cause All Sorts of Issues Apparently – Who Knew?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-eight-tick-tock-goes-the-clock-but-will-it-aid-space-travel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: Tick Tock Goes the Clock, but Will It Aid Space Travel?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-nine-being-covered-in-talc-can-hinder-invisibility-just-saying",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: Being Covered in Talc Can Hinder Invisibility – Just Saying")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-ten-scientists-ask-can-sticking-your-finger-in-your-belly-button-really-make-your-bum-fall-off",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten: Scientists Ask: “Can Sticking Your Finger in Your Belly Button Really Make Your Bum Fall Off?”")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-eleven-has-anyone-seen-my-marbles-i-am-sure-i-had-them",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven: Has Anyone Seen My Marbles? I Am Sure I Had Them…")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-twelve-is-manure-a-delicacy-asking-for-a-friend-says-random-chap",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve: “Is Manure a Delicacy?” Asking for a Friend, Says Random Chap")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-thirteen-apparently-a-slap-in-the-face-with-a-wet-fish-will-not-aid-space-travel-they-did-not-tell-me-this",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen: Apparently, a Slap in the Face with a Wet Fish Will Not Aid Space Travel – They Did Not Tell Me This")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-fourteen-baked-beans-cause-bottom-gas-but-it-is-not-enough-to-aid-space-travelwhy-does-anybody-not-tell-me-these-things",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen: Baked Beans Cause Bottom Gas But It Is Not Enough to Aid Space Travel…Why Does Anybody Not Tell Me These Things?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-fifteen-moofus-mc-radling-the-moons-pancake-mix-specialist-arrives-on-earth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen: Moofus-Mc-Radling, the Moon’s Pancake Mix Specialist Arrives on Earth!")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0